export default __webpack_public_path__ + "static/media/logo1.f25f986c.png";